// @flow

import React from 'react';
import { SubscriptionFieldDescription } from 'shared_components/common/subscription/Description';

/**
 * subscribeFragment
 */
export const subscribeFragment = [
  {
    tag: 'customRenderer',
    name: 'subscribeDescription',
    isFormItem: false,
    customRenderer: ({ intl }: Object) => {
      return <SubscriptionFieldDescription formatMessage={intl.formatMessage} />;
    },
  },
  {
    tag: 'subscribeSection',
    name: 'subscribe',
    validateTrigger: 'onBlur',
    rules: [
      {
        required: true,
        message: 'forms.common.validation_messages.not_empty_subscribe',
      },
    ],
    label: false,
  },
];
